import { IPermissions } from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const loadPermissions = createAction('[Permissions] Load Permissions');
export const loadPermissionsSuccess = createAction(
  '[Permissions] Load Permissions Success',
  props<{ permissions: IPermissions[] }>(),
);
